abstract class Status {

  public getValue(): number {
    return Object.getPrototypeOf(this).constructor.statusId;
  }
}

export { Status }
